<template>
  <div id="app">
    <router-view :workbench="workbenchData" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      workbenchData: {
        workOrderCount: 0, // 工单数量：
        expatriateOrderCount: 0, // 外派订单数量：
        partsOrderCount: 0, // 配件订单数量：
        roleTips: "administrators", // 角色tips： projectManager  accessoriesSpecialist technicalSupport
      },
    };
  },
  methods: {
    getData() {
      this.ccRequest.do("admin/fsb/work/order/workbench", {}).then((res) => {
        this.workbenchData = {
          workOrderCount: res.workOrderCount,
          expatriateOrderCount: res.expatriateOrderCount,
          partsOrderCount: res.partsOrderCount,
          roleTips: res.roleTips,
        };
        let sendMsg = false;
        let htmlText = "";
        let arr = [
          "technicalSupport",
          "accessoriesSpecialist",
          "projectManager",
          "afterSalesManager"
        ];
        if (res.workOrderCount > 0
        // && arr.indexOf(res.roleTips) > -1
        ) {
          htmlText += `<div>你有${this.workbenchData.workOrderCount}条服务请求未处理</div>`;
          sendMsg = true;
        }
        if (
          res.expatriateOrderCount > 0
          // && res.roleTips == "technicalSupport"
        ) {
          htmlText += `<div>你有${this.workbenchData.expatriateOrderCount}条外派订单未处理</div>`;
          sendMsg = true;
        }
        if (
          res.partsOrderCount > 0
          // &&
          // res.roleTips == "accessoriesSpecialist"
        ) {
          htmlText += `<div>你有${this.workbenchData.partsOrderCount}条配件订单未处理</div>`;
          sendMsg = true;
        }
        if (sendMsg) {
          this.$notify.info({
            title: "新消息提醒",
            dangerouslyUseHTMLString: true,
            message: htmlText,
            position: "bottom-right",
          });
        }
        // console.log(res, "工作台")
      }); //600000
    },
    showNewMsg() {
      this.getData();
      setInterval(() => {
        this.getData();
      }, 600000);
    },
    getLanguage() {
      /*拿数据库保存的当前账号所设定的语言*/
      this.ccRequest.do("mgr/getLanguage", {}, "GET").then((res) => {
        this.$lange = res.language;
        localStorage.setItem("lange", res.language);
      });
    },
  },
  mounted() {
    try {
      if (window.location.href.indexOf("admin/sys/login") == -1) {
        this.showNewMsg();
        this.getLanguage();
      }
    } catch (error) {}
  },
};
</script>
<style lang="scss">
.break-word {
  .el-radio .el-radio__label {
    word-break: normal;
    width: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }
}
.el-tabs {
  .table-bottom {
    .el-table__fixed-right {
      bottom: 16px !important;
    }
  }

  *::-webkit-scrollbar {
    width: 7px;
    height: 15px;
  } /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  *::-webkit-scrollbar-track {
    background-color: #f0f6ff;
  } /*定义滚动条轨道 内阴影+圆角*/
  *::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    z-index: 999999;
  } /*定义滑块 内阴影+圆角*/
  .scrollbarHide::-webkit-scrollbar {
    display: block;
  }
  .scrollbarShow::-webkit-scrollbar {
    display: block;
  }
}

* {
  margin: 0;
  padding: 0;
}
.require-class:before {
  content: "*";
  color: #f00;
  transform: translateX(-3px);
}
.require-class2::after {
  content: "*";
  color: #f00;
  padding-left: 3px;
}
.require-class2::before {
  content: "";
  color: #f0f6ff;
}
/*修改el-input 的圆角*/
.el-input__inner,
.el-textarea__inner {
  border-radius: 2px !important;
}
/*修改tab 页的边距*/
.el-tabs__content {
  padding: 0 !important;
}
.el-tabs__nav {
  .el-tabs__item {
    font-size: 18px !important;
    font-weight: bolder !important;
  }
}
/*去掉表格的边距*/
.not-padding .el-card__body {
  padding: 0 !important;
}
#app {
  background: #f3f3f4;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 5px;
  font-size: 14px;
  position: relative;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/*单行文字溢出 ...*/
.row-clip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*返回按钮样式*/
.back-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  .el-button--mini {
    padding: 5px 10px;
    font-size: 16px;
  }
}
/*限制富文本编辑器高度*/
.quill-editor.quill-editor.quill-editor {
  // height: 275px !important;
  height: 243px!important;

}
.ql-editor {
  box-sizing: border-box;
}
.ql-container.ql-container.ql-container {
  height: 200px !important;
}
.el-upload {
  line-height: 0;
}
</style>

<style lang="scss" >
// .el-dialog__title {
//   margin-left: 20px;
// }
textarea{
  font-family: '"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif' !important;
}
</style>
